import { format } from 'date-fns';
import { formatCurrency } from '@ibk/shared-utils';
import { EMISSOR_ORDER_STATUS_LABELS, EmissorOrderScreenStatus } from '../../types/emissor-order-history';
export function parseCompetenceToDate(competence) {
    const match = /^(\d{4})-(\d{2})/.exec(competence?.trim() ?? '');
    if (!match) {
        return null;
    }
    const [, year, month] = match;
    return new Date(Number(year), Number(month) - 1, 1);
}
export function formatPayrollDiscount(discountType, discountValue, t) {
    if (!discountType) {
        return t('no');
    }
    if (discountType === 'PERCENTAGE') {
        const value = discountValue ?? 0;
        return new Intl.NumberFormat('pt-BR', {
            style: 'percent',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        })
            .format(value / 100)
            .replace(/^(\d{1,3}(\.\d{3})*),(\d{2})%$/, '% $1,$3');
    }
    return formatCurrency(discountValue ?? 0);
}
export function formatPaidAt(createdAt) {
    if (!createdAt) {
        return '';
    }
    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return format(date, 'dd/MM/yyyy HH:mm');
}
export function formatPaymentMethod(method, t) {
    if (method === 'PIX') {
        return t('benefits.recharge-details.paid-via.pix');
    }
    if (method === 'BANKSLIP') {
        return t('benefits.recharge-details.paid-via.bankslip');
    }
    return '';
}
export function resolveStatusLabel(screenStatus, t) {
    if (!screenStatus) {
        return '';
    }
    const key = EMISSOR_ORDER_STATUS_LABELS[screenStatus];
    return key ? t(key) : String(screenStatus);
}
export function shouldShowPaidInfo(order, screenStatus) {
    if (!order.payment) {
        return false;
    }
    if (!screenStatus) {
        return order.payment.status === 'CREATED';
    }
    return (screenStatus === EmissorOrderScreenStatus.RELEASING_CREDIT ||
        screenStatus === EmissorOrderScreenStatus.CREDIT_RELEASED);
}
